@if (meetingInfoVm$ | async; as meetingDetails) {
<div class="container main-container">
  <div class="meeting-info-header">
    <img
      src="/assets/images/confirm-tick.svg"
      alt="Confirm"
      class="confirm-icon"
    />
    <p class="header-text" i18n="@@MEETING_INFO.ALL_SET_TITLE">
      {{ 'MEETING_INFO.ALL_SET_TITLE' | translate }}
    </p>
    <p class="secondary-text-color" i18n="@@MEETING_INFO.ALL_SET_DESCRIPTION">
      {{ 'MEETING_INFO.ALL_SET_DESCRIPTION' | translate }}
    </p>
    @if (isRedirecting) {
      <p class="redirect-notice secondary-text-color" role="status" aria-live="polite">
        <mat-icon class="redirect-notice-icon">schedule</mat-icon>
        <span i18n="@@MEETING_INFO.REDIRECTING">Redirecting in {{ redirectSecondsRemaining }} seconds...</span>
      </p>
    }
  </div>
  <div class="margin-top-20">
    <div class="header-details">
      <mat-icon class="icon">person</mat-icon>
      <div class="header-title">{{ 'CANCEL_INFO.DETAILS' | translate }}</div>
    </div>
    <div class="component-body profile-backdrop">
      <p class="primary-text">{{ meetingDetails.displayTitle }}</p>
      <p class="secondary-text-color">
        with {{ meetingDetails.hostNamesText }}
      </p>
    </div>
  </div>
  <div class="margin-top-20">
    <div class="header-details">
      <mat-icon class="icon">today</mat-icon>
      <div class="header-title">{{ 'CANCEL_INFO.WHEN' | translate }}</div>
    </div>
    <div class="component-body calendar-backdrop">
      <p class="primary-text">{{ meetingDetails.dateText }}</p>
      <div class="flex-space-between">
        <div class="secondary-text-color">
          {{ meetingDetails.timeRangeText }}
          {{ meetingDetails.timezoneZoneText }}
        </div>
        <div class="display-duration">{{ meetingDetails.durationText }}</div>
      </div>
    </div>
  </div>
  <div class="margin-top-20">
    <div class="header-details">
      <mat-icon class="icon">location_on</mat-icon>
      <div class="header-title">{{ 'CANCEL_INFO.WHERE' | translate }}</div>
    </div>
    @if (meetingDetails.isBatch && meetingDetails.isInPerson) {
      @for (meeting of meetingDetails.meetings; track meeting.meetingId) {
        @if (meeting.location) {
        <div class="component-body location-backdrop batch-meeting-link-box">
          <p class="batch-meeting-title">{{ meeting.eventTypeName }}</p>
          <p class="primary-text">{{ meeting.location }}</p>
          <div class="anchor-tag" (click)="navigateToGoogleMaps(meeting.location)">
            <img src="/assets/images/direction.svg" alt="Direction" class="direction-icon" />
            {{ 'MEETING_INFO.GET_DIRECTIONS' | translate }}
          </div>
        </div>
        } @else {
        <div class="component-body secondary-text-color location-backdrop batch-meeting-link-box">
          {{ meeting.eventTypeName }} - {{ 'CANCEL_INFO.ONLINE_APPOINTMENT' | translate }}
        </div>
        }
      }
    } @else if (meetingDetails.isBatch && !meetingDetails.isInPerson) {
      <div class="component-body secondary-text-color location-backdrop">
        {{ 'CANCEL_INFO.ONLINE_APPOINTMENT' | translate }}
      </div>
    } @else {
      @if (meetingDetails.isInPerson) {
      <div class="component-body location-backdrop">
        <p class="primary-text">{{ meetingDetails.meetingInfo.location }}</p>
        <div class="anchor-tag" (click)="navigateToGoogleMaps(meetingDetails.meetingInfo.location)">
          <img src="/assets/images/direction.svg" alt="Direction" class="direction-icon" />
          {{ 'MEETING_INFO.GET_DIRECTIONS' | translate }}
        </div>
      </div>
      } @else {
      <div class="component-body secondary-text-color location-backdrop">
        {{ 'CANCEL_INFO.ONLINE_APPOINTMENT' | translate }}
      </div>
      }
    }
  </div>
  <div class="margin-top-20">
    <div class="header-details">
      <mat-icon class="icon">link</mat-icon>
      <div class="header-title">{{ 'MEETING_INFO.MEETING_LINK' | translate }}</div>
    </div>
    @if (meetingDetails.isBatch && meetingDetails.hasMeetingLink) {
      @for (meeting of meetingDetails.meetings; track meeting.meetingId) {
        @if (meeting.meetingSourceLink) {
        <div class="component-body meeting-link-backdrop batch-meeting-link-box">
          <p class="batch-meeting-title">{{ meeting.eventTypeName }} - {{ meeting.meetingSourceText }} Meeting</p>
          <div class="flex-space-between">
            <button
              mat-button
              mat-flat-button
              color="primary"
              class="outlined-button"
              (click)="openLinkInNewTab(meeting.meetingSourceLink)"
            >
              <div class="button-content">
                <img
                  src="/assets/images/video.svg"
                  alt="video-icon"
                  class="direction-icon"
                />
                Join with {{ meeting.meetingSourceText }}
              </div>
            </button>
            <div
              class="anchor-tag"
              (click)="navigateToHelpLink(meeting.meetingSource)"
            >
              <img
                src="/assets/images/need-help-joining.svg"
                alt="need-help-joining"
                class="direction-icon need-help-icon"
              />
              <div i18n="@@MEETING_INFO.NEED_HELP_JOINING">
                {{ 'MEETING_INFO.NEED_HELP_JOINING' | translate }}
              </div>
            </div>
          </div>
        </div>
        } @else if (meeting.location) {
        <div class="component-body secondary-text-color meeting-link-backdrop batch-meeting-link-box">
          {{ meeting.eventTypeName }} - {{ 'MEETING_INFO.IN_PERSON_APPOINTMENT_SHORT' | translate }}
        </div>
        }
      }
    } @else if (meetingDetails.isVideo && meetingDetails.hasMeetingLink) {
    <div class="component-body meeting-link-backdrop">
      <p>{{ meetingDetails.meetingInfo.title }}</p>
      <div class="flex-space-between">
        <button
          mat-button
          mat-flat-button
          color="primary"
          class="outlined-button"
          (click)="
            openLinkInNewTab(meetingDetails.meetingInfo.meetingSourceLink)
          "
        >
          <div class="button-content">
            <img
              src="/assets/images/video.svg"
              alt="video-icon"
              class="direction-icon"
            />
            Join with {{ meetingDetails.meetingSourceText }}
          </div>
        </button>
        <div
          class="anchor-tag"
          (click)="navigateToHelpLink(meetingDetails.meetingInfo.meetingSource)"
        >
          <img
            src="/assets/images/need-help-joining.svg"
            alt="need-help-joining"
            class="direction-icon need-help-icon"
          />
          <div i18n="@@MEETING_INFO.NEED_HELP_JOINING">
            {{ 'MEETING_INFO.NEED_HELP_JOINING' | translate }}
          </div>
        </div>
      </div>
    </div>
    } @else if (meetingDetails.isVideo && !meetingDetails.hasMeetingLink) {
    <div
      class="component-body secondary-text-color meeting-link-backdrop text-center"
    >
      {{ meetingDetails.meetingLinkFallbackText }}
    </div>
    } @else if (!meetingDetails.isVideo) {
    <div class="component-body secondary-text-color meeting-link-backdrop">
      {{ 'MEETING_INFO.IN_PERSON_APPOINTMENT' | translate }}
    </div>
    }
  </div>
  <div
    class="margin-top-20 flex-center-align component-body padding-30 add-to-calendar-section"
  >
    <div>{{ 'MEETING_INFO.ADD_TO_CALENDAR' | translate }}</div>
    @if (meetingDetails.hasCalendarLinks) {
    <div class="add-to-calendar-actions">
      @if (meetingDetails.meetingInfo.googleCalendarLink) {
      <button
        mat-button
        mat-flat-button
        class="outlined-button"
        (click)="
          openLinkInNewTab(meetingDetails.meetingInfo.googleCalendarLink)
        "
      >
        <div class="button-content">
          <img
            src="/assets/images/google.svg"
            alt="google"
            class="direction-icon"
          />
          {{ 'MEETING_INFO.GOOGLE' | translate }}
        </div>
      </button>
      } @if (meetingDetails.meetingInfo.outlookCalendarLink) {
      <button
        mat-button
        mat-flat-button
        class="outlined-button"
        (click)="
          openLinkInNewTab(meetingDetails.meetingInfo.outlookCalendarLink)
        "
      >
        <div class="button-content">
          <img
            src="/assets/images/outlook-team.svg"
            alt="outlook"
            class="direction-icon"
          />
          {{ 'MEETING_INFO.OUTLOOK' | translate }}
        </div>
      </button>
      }
    </div>
    } @if (!meetingDetails.hasCalendarLinks) {
    <div class="secondary-text-color text-center">
      {{ meetingDetails.calendarLinkFallbackText }}
    </div>
    }
  </div>
  <div class="margin-top-20 flex-row-center">
    <div i18n="@@MEETING_INFO.NEED_TO_MAKE_CHANGES">
      {{ 'MEETING_INFO.NEED_TO_MAKE_CHANGES' | translate }}
    </div>
    <div
      class="reschedule-anchor"
      (click)="openLinkInNewTab(meetingDetails.meetingInfo.rescheduleLink)"
    >
      {{ 'BOOK.RESCHEDULE' | translate }}
    </div>
    {{ 'MEETING_INFO.OR' | translate }}
    <div
      class="cancel-anchor"
      (click)="openLinkInNewTab(meetingDetails.meetingInfo.cancelLink)"
    >
      {{ 'CANCEL_INFO.CANCEL' | translate }}
    </div>
  </div>
  @if (meetingDetails.businessLogo) {
  <div class="margin-top-20 flex-center-align">
    <img
      [src]="meetingDetails.businessLogo"
      alt="Business Logo"
      class="business-logo"
    />
  </div>
  }
</div>
} @else {
<div class="row row-gutters">
  @for (i of [].constructor(6); track i) {
  <div class="col col-xs-12 col-sm-6">
    <div class="stencil-shimmer meeting-type-card">
      <div
        class="meeting-type-icon mat-elevation-z2 stencil-shimmer disappear-on-mobile"
      ></div>
    </div>
  </div>
  }
</div>
}
